<template>
  <b-form :class="mensajeError ? 'mt-5' : 'mt-2'" @submit="onSubmit" ref="form" lazy-validation>
    <div v-if="mensajeError != ''">
      <b-alert class="mensaje-error" show>{{ mensajeError }}</b-alert>
    </div>
    <div class="usuario-confirmado text-center text-white mb-3">
      <div class="saludo">{{ nombreCompleto || username }}</div>
      <div class="ultima-conexion">{{ textoConexion }}</div>
      <b-link class="cambiar-usuario" @click="$emit('volver')">¿No eres tú? Cambiar usuario</b-link>
    </div>
    <b-form-group>
      <b-form-input id="txt-pwd" class="form-input" type="password" placeholder="Contraseña" v-model="password"
        required autofocus>
      </b-form-input>
      <b-form-invalid-feedback id="txt-pwd-invalid">Ingrese la contraseña</b-form-invalid-feedback>
    </b-form-group>
    <b-form-group>
      <b-form-input id="txt-servidor" type="text" class="form-input" placeholder="Servidor" v-model="servidor"
        required>
      </b-form-input>
    </b-form-group>
    <b-button class="btn-login mt-4 margen-boton-login" type="submit" variant="info" size="lg" block
      :disabled="busy || !formatoServidorValido">
      INICIAR SESIÓN
    </b-button>
  </b-form>
</template>

<script>
import moment from "moment";
import { tieneFormatoDeServidorValido, normalizeServidor } from "../../utils/Utils";

export default {
  name: "LoginPasswordStep",
  props: {
    username: {
      type: String,
      required: true,
    },
    nombreCompleto: {
      type: String,
      default: "",
    },
    grupo: {
      type: String,
      default: null,
    },
    ultimaConexion: {
      type: [String, Date],
      default: null,
    },
    servidorInicial: {
      type: String,
      default: "",
    },
    mensajeError: {
      type: String,
      default: "",
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      password: "",
      servidor: this.servidorInicial,
    };
  },
  computed: {
    textoConexion() {
      if (!this.ultimaConexion) {
        return "Primera vez";
      }
      return `Última conexión: ${moment(this.ultimaConexion).format("DD/MM/YYYY HH:mm")}`;
    },
    formatoServidorValido() {
      return tieneFormatoDeServidorValido(this.servidor);
    },
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      localStorage.setItem("servidor", normalizeServidor(this.servidor));
      this.$emit("submit", { password: this.password, servidor: this.servidor });
    },
  },
};
</script>

<style scoped>
.saludo {
  font-size: 1.1rem;
  font-weight: 600;
}

.grupo {
  font-size: 0.85rem;
  opacity: 0.85;
}

.ultima-conexion {
  font-size: 0.85rem;
  opacity: 0.85;
  margin-bottom: 0.35rem;
}

.cambiar-usuario {
  color: #9fd3f0;
  font-size: 0.85rem;
  cursor: pointer;
}
</style>
